/* ============
 * Contact Transformer
 * ============
 *
 * The transformer for the contact.
 */

import Transformer from './transformer';

export default class ContactTransformer extends Transformer {
  /**
   * Method used to transform a fetched contact
   *
   * @param contact The fetched contact
   *
   * @returns {Object} The transformed contact
   */
  static fetch(contact) {
    return {
      email: contact.email,
      firstName: contact.first_name,
      lastName: contact.last_name,
      phoneNumber: contact.phone_number,
      mobileNumber: contact.mobile_number,
    };
  }

  /**
   * Method used to transform a send contact
   *
   * @param contact The contact to be send
   *
   * @returns {Object} The transformed contact
   */
  static send(contact) {
    return {
      email: contact.email,
      first_name: contact.firstName,
      last_name: contact.lastName,
      phone_number: contact.phoneNumber,
      mobile_number: contact.mobileNumber,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/contact.js